import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress,Button } from '@material-ui/core';


class IDDupDiag extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false,
            status: 'Please select an option...',
            warning: '',
            canSubmit: true,
            submitting: false,
            selectedOption: '',
        }
    }
    
    render() {
        return (
            <div>
                <h3>Previous Details Found</h3>
                <p>There seems be a record on file for you already, associated with the email address: <b>{this.props.old_email}</b><br/><br/>
                 Please select an option below, in order to proceed...
                 <br/>
                </p>
                <div style={{marginLeft:'20%',textAlign:'left', marginRight:'20%'}}>
                    <div style={{color:this.state.selectedOption==='A'? 'blue' : 'inherit'}}>
                        <input  type="radio" disabled={this.state.submitting} name='dupl_id_response' id="A" value='A' onChange={this.fieldHandler}/><label htmlFor="A"><i>{this.props.old_email}</i> is an old address which I no longer use, and I would like to use <u>this new one I've just entered</u> from now on. Contact me at the address <b>{this.props.new_email}</b> in future.</label><br/><br/>
                    </div>
                    <div style={{color:this.state.selectedOption==='B'? 'blue' : 'inherit'}}>
                        <input type="radio" disabled={this.state.submitting} name='dupl_id_response' id="B" value='B' onChange={this.fieldHandler}/><label htmlFor="B"><i>{this.props.old_email}</i> is another active email address of mine, and I would like to continue to use <u>that old email address</u> instead of the new one I've just entered. Contact me at the address <b>{this.props.old_email}</b> in future.</label><br/><br/>
                    </div>
                    <div style={{color:this.state.selectedOption==='C'? 'red' : 'inherit'}}>
                        <input type="radio" disabled={this.state.submitting} name='dupl_id_response' id="C" value='C' onChange={this.fieldHandler}/><label htmlFor="C">I <u>don't recognise</u> the address <b>{this.props.old_email}</b> - it's not mine!</label><br/>
                    </div>
                </div>
                <br/>

                <Button
                    variant='contained'
                    size='large'
                    color='primary'
                    id="Submit"
                    type='submit'
                    onClick={this.submitHandler}
                    disabled={!this.state.selectedOption||this.state.submitting}
                >
                    <span id="s1" >Submit</span>
                </Button>
                {/* <button id="Submit" className="button" style={{verticalAlign:'middle'}} onClick={this.submitHandler} disabled={!this.state.selectedOption||this.state.submitting}><span id="s1" >Submit</span></button> */}

                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
            </div>
        );

    }
    
    submitHandler = (e) => {
        
    //   console.log('Pressed submit - status value: ',this.state.selectedOption);
      this.setState({status:'Processing...',showSpinner:true,submitting:true});
      //Need to now either 1) show regret / please contact us screen if they don't recognise the email! - option C or 2) send command to remove the new user, if option B has been selected (i.e. wants to use old email) - suggest conformation screen; or 3) head on to Mobile OTP to test against old mobile, and if successful remove new user and change old user's email address! [The most difficult part]. also do confirmation screen.
      
      switch (this.state.selectedOption) {
        case "C":
            this.props.setParentState({showIDDuplicateDialog:false,showRegret:true});
        break;
    
        case "B":
            //Send remove request for current user... not too serious if it isn't removed...
            // console.log('Removing partial user...');
            GServ.remove_partial_user(this.props.gwt)
            .then(removalResult => {
                // console.log('Server reply on removal request => ',removalResult);
            });
            //Now reset to original screen;
            this.props.resetParentState();
        break;

        case "A":
            // console.log('Removing partial user...');
            GServ.remove_partial_user(this.props.gwt)
            .then(removalResult => {
                console.log('Server reply on removal request => ',removalResult);
                //In future, only log if failed...
            });
            //Head to mobile OTP verification stuff to start handling email changes...
            this.props.setParentState({showIDDuplicateDialog:false,showMobileConf:true});
        break;
      
        default:
        break;

      }

    }

    fieldHandler = (e) => {
        // console.log('Selected Option value:',e.target.value)
        this.setState({selectedOption:e.target.value});
        this.setState({status:''});
        // console.log('change on => ',e.target.name);
    }

}

export default IDDupDiag;